// extracted by mini-css-extract-plugin
module.exports = {"container":"container__3QFYx","icon":"icon__2aZmW","h":"h__2HQf5","desc":"desc__oDRMG"};